// ============================================================
// Gupta Enterprises — Vasavi Gold
// Central content & configuration. Edit values here anytime.
// ============================================================

export const CONTACT = {
  companyName: "Gupta Enterprises",
  brand: "Vasavi Gold",
  founder: "S. V. N. Gupta & S. V. V. S. N. Gupta",
  founded: "1975",
  // Update these with your real details anytime:
  phoneDisplay: "+91 94912 91618",
  phoneDial: "+919491291618",
  whatsapp: "919491291618", // country code + number, no symbols
  email: "svvsngupta9@gmail.com",
  addressLines: [
    "Chemudulanka",
    "Dr. B. R. Ambedkar Konaseema District",
    "Andhra Pradesh 533234, India",
  ],
  mapQuery: "Chemudulanka, Dr. B.R. Ambedkar Konaseema, Andhra Pradesh 533234, India",
};

export const IMAGES = {
  heroField:
    "https://images.pexels.com/photos/6130382/pexels-photo-6130382.jpeg?auto=compress&cs=tinysrgb&w=1920",
  paddy:
    "https://images.pexels.com/photos/2589457/pexels-photo-2589457.jpeg?auto=compress&cs=tinysrgb&w=1400",
  grainsMacro:
    "https://images.pexels.com/photos/7665442/pexels-photo-7665442.jpeg?auto=compress&cs=tinysrgb&w=1000",
  grainsRaw:
    "https://images.pexels.com/photos/4110251/pexels-photo-4110251.jpeg?auto=compress&cs=tinysrgb&w=1000",
  grainsLong:
    "https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&w=1000&q=80",
  bowlCooked:
    "https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?auto=format&fit=crop&w=1000&q=80",
};

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Story", id: "story" },
  { label: "Products", id: "products" },
  { label: "Markets", id: "markets" },
  { label: "Values", id: "values" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const WHY_CHOOSE = [
  { icon: "Award", title: "Better Quality", desc: "Every batch is carefully sorted and graded to meet a premium standard you can trust." },
  { icon: "Tag", title: "Affordable Prices", desc: "Premium rice priced fairly — exceptional quality without the premium markup." },
  { icon: "Truck", title: "Fast Delivery", desc: "Reliable, timely dispatch that keeps your shelves and kitchens always stocked." },
  { icon: "Handshake", title: "Honest Business", desc: "Transparent dealings and consistent grades. What we promise is what you receive." },
  { icon: "LayoutGrid", title: "Wide Product Range", desc: "From Sona Masoori to Idli rice — one dependable source for every requirement." },
  { icon: "HeartHandshake", title: "Personalized Service", desc: "A family business that knows its customers by name and serves them personally." },
  { icon: "Users", title: "Strong Dealer Network", desc: "Long-term partnerships built on reliability, fair pricing and mutual growth." },
];

export const PRODUCTS = [
  { name: "Sona Masoori", tag: "Everyday Premium", desc: "Lightweight, aromatic and easy to digest — the beloved everyday table rice of South India.", img: IMAGES.grainsLong },
  { name: "Steam Rice", tag: "Soft & Fluffy", desc: "Parboiled and steam-processed for fluffy, non-sticky grains that hold their shape beautifully.", img: IMAGES.bowlCooked },
  { name: "Raw Rice", tag: "Pure & Natural", desc: "Naturally milled raw rice retaining its wholesome texture, aroma and authentic flavour.", img: IMAGES.grainsRaw },
  { name: "Premium Rice", tag: "Signature Grade", desc: "Our finest, hand-selected long grains reserved for the most discerning kitchens.", img: IMAGES.grainsMacro },
  { name: "Idli Rice", tag: "Soft Fermentation", desc: "Specially suited for idli and dosa batters — soft, absorbent and perfectly fermenting.", img: IMAGES.paddy },
  { name: "Broken Rice", tag: "Value Choice", desc: "Economical broken grains ideal for porridge, batters and high-volume kitchens.", img: IMAGES.grainsRaw },
];

export const MARKETS = [
  { icon: "Store", title: "Retail Shops" },
  { icon: "Handshake", title: "Dealers" },
  { icon: "Boxes", title: "Distributors" },
  { icon: "ShoppingCart", title: "Supermarkets" },
  { icon: "UtensilsCrossed", title: "Hotels & Restaurants" },
  { icon: "Ship", title: "Export Buyers" },
  { icon: "User", title: "Individual Customers" },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Years of Legacy" },
  { value: 6, suffix: "", label: "Product Categories" },
  { value: 500, suffix: "+", label: "Happy Business Partners" },
  { value: 10, suffix: "K+", label: "Growing Customer Base" },
];

export const TIMELINE = [
  { year: "1975", title: "The Beginning", desc: "The family's journey in the rice business began under the leadership of S. V. N. Gupta." },
  { year: "Transition", title: "Leadership Transition", desc: "S. V. V. S. N. Gupta carried forward the family legacy, expanding and modernizing the business." },
  { year: "Today", title: "Gupta Enterprises", desc: "The business proudly operates as Gupta Enterprises, delivering premium-quality rice under the Vasavi Gold brand." },
  { year: "Future", title: "Expanding Horizons", desc: "Continuing a legacy of excellence while expanding our presence across India and international markets." },
];

export const CORE_VALUES = [
  { icon: "ShieldCheck", title: "Integrity", desc: "We do honest business, always." },
  { icon: "Sparkles", title: "Quality", desc: "Premium grade, batch after batch." },
  { icon: "Handshake", title: "Trust", desc: "Relationships that last generations." },
  { icon: "Smile", title: "Customer Satisfaction", desc: "Your kitchen, our commitment." },
  { icon: "TrendingUp", title: "Growth", desc: "Growing together with our partners." },
  { icon: "Lightbulb", title: "Innovation", desc: "Better sourcing, smarter service." },
];

export const MANIFESTO = [
  { num: "01", title: "Every grain, considered.", desc: "We treat rice as the heart of the meal — sorting, grading and packing each batch with the care a family gives its own table." },
  { num: "02", title: "Trust, earned daily.", desc: "Consistency is our craft. The quality you receive today is the quality you will receive next season, and the season after." },
  { num: "03", title: "A legacy in the making.", desc: "Carried forward across generations, Vasavi Gold is built to serve households and businesses across India and beyond." },
];

export const FAQS = [
  { q: "What products do you distribute?", a: "We distribute a premium range of rice under the Vasavi Gold brand — Sona Masoori, Steam Rice, Raw Rice, Premium Rice, Idli Rice and Broken Rice." },
  { q: "Do you supply bulk orders?", a: "Yes. We specialise in bulk supply for retailers, distributors, supermarkets, hotels and restaurants. Share your requirement through the enquiry form and our team will respond promptly." },
  { q: "How can dealers contact you?", a: "Dealers and distributors can reach us directly on WhatsApp or phone, or submit a Business Enquiry using the form below. We love building long-term dealer relationships." },
  { q: "Do you support export enquiries?", a: "Absolutely. We welcome export buyers and are actively growing the Vasavi Gold brand in global markets. Mention 'Export' in your enquiry and we'll get in touch." },
  { q: "Can businesses request quotations?", a: "Yes. Send us your product, quantity and delivery location via the enquiry form or WhatsApp, and we'll share a competitive quotation." },
];
